import { theme } from "@icg360/design-system";

import type { ProductIcons } from "./types";

export enum BREAKPOINTS {
  sm = "640px",
  md = "800px",
  lg = "1024px",
  xl = "1400px",
  "2xl" = "1600px"
}

export const PRODUCT_ICONS: ProductIcons = {
  ELIGIBLE: {
    LABEL: "",
    ICON: {
      NAME: "Success",
      COLOR: theme.colors.fill.success,
      TEXT: "Eligible",
      TEXTCOLOR: theme.colors.text.success,
      BGCOLOR: "#FAFFF6"
    }
  },
  INFORM: {
    LABEL: "INFORM",
    ICON: {
      NAME: "Information",
      COLOR: theme.colors.fill.default,
      TEXT: "",
      TEXTCOLOR: "",
      BGCOLOR: ""
    }
  },
  PREVENT: {
    LABEL: "PREVENT",
    ICON: {
      NAME: "Ineligible",
      COLOR: theme.colors.fill.danger,
      TEXT: "Ineligible",
      TEXTCOLOR: theme.colors.text.danger,
      BGCOLOR: "#FFF1F4"
    }
  },
  BLOCK: {
    LABEL: "BLOCK",
    ICON: {
      NAME: "Warning",
      COLOR: theme.colors.fill.warning,
      TEXT: "Referable",
      TEXTCOLOR: theme.colors.fill.warning,
      BGCOLOR: "#FFFAF4"
    }
  },
  STOP: {
    LABEL: "STOP",
    ICON: {
      NAME: "Flag",
      COLOR: theme.colors.fill.default,
      TEXT: "",
      TEXTCOLOR: "",
      BGCOLOR: ""
    }
  },
  RATING_ERROR: {
    LABEL: "RATING_ERROR",
    ICON: {
      NAME: "Warning",
      COLOR: theme.colors.fill.warning,
      TEXT: "Referable",
      TEXTCOLOR: theme.colors.fill.warning,
      BGCOLOR: "#FFFAF4"
    }
  }
};

export const PRODUCT_BADGES = {
  ELIGIBLE: {
    APPEARANCE: "success",
    TEXT: "Eligible"
  },
  PREVENT: {
    APPEARANCE: "danger",
    TEXT: "Ineligible"
  },
  BLOCK: {
    APPEARANCE: "warning",
    TEXT: "Referable"
  }
};

// Hard coded relevant resource links for messages tab
// todo replace with dynamic resources at some point
export const relevantResourceLinks: { label: string; url: string }[] = [
  {
    label: "Understanding Inflations Impact on Homeowners Premiums",
    url: "https://sagesure.widen.net/s/xldmg7c8cv/sagesure-flyer---inflation-impact-general"
  },
  {
    label: "Learn about our inspection process",
    url: "https://sagesure.widen.net/s/zrcwsjpnnp/sagesure-elements-for-success_inspections"
  },
  {
    label:
      "SageSure Webinar: Roof Risks - Inspection Concerns to Underwriting Referrals",
    url: "https://sagesure.widen.net/s/plp6xc65dp/sagesure-elements-for-success_pending-cancellations"
  }
];

export const QUOTE_UTILITY_TABS = {
  PROPERTY_INSIGHT: "PROPERTY_INSIGHT",
  MESSAGES: "MESSAGES",
  COMPARE_PRODUCTS: "COMPARE_PRODUCTS"
};
